<template>
    <div id="chart">
    </div>
</template>
<script>

import ApexCharts from 'apexcharts'
import { getListUserExcerice } from './../../_api/lessonClassSchoolUserServices';

export default {
    name: 'ChartPointInClass',
    components: { ApexCharts },
    props: {
        classSchoolId: {
            type: Number,
            default: 0
        },
        lessonClassSchoolId: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'ElectronicLecture'
        },
    },
    data() {
        return {
            listMember: [],
            paramQueryDataMember: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
                subjectId: 0,
                classId: 0,
                classSchoolId: 0,
                lessonClassSchoolId: 0,
                isGetByAll: true
            },
            options: {
                series: [{
                    name: 'Số bài đạt điểm',
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }],
                chart: {
                    type: 'bar',
                    height: 300
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                        dataLabels: {
                            position: 'center', // top, center, bottom
                        },
                    },
                },
                xaxis: {
                    categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                },
                yaxis: {
                    title: {
                        text: 'Số bài đạt điểm'
                    },
                    tickAmount: 20,
                    min: 0,
                    max: 10,
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                },
                colors: ['#145aa5'],
                noData: {
                    text: 'Đang tải dữ liệu biểu đồ...'
                },
            },
            yMax: 10,
        }
    },
    watch: {
        'lessonClassSchoolId': 'getListMember',
        'listMember': 'updateChart',
    },
    mounted() {
        //this.renderChart()
        if (this.lessonClassSchoolId > 0) {
            this.getListMember()
        }
    },
    methods:{
        formatNumber(value){
            if (typeof value !== 'number') {
                return value;
            }
            if (value % 1 == 0.5) {
                return value.toFixed(1);
            }
            return value.toFixed(0);
        },
        renderChart() {
            if (this.options.series.length > 0) {
                const chartElement = document.querySelector("#chart");
                chartElement.innerHTML = ''
                var chart = new ApexCharts(chartElement, this.options);
                chart.render();
            }
        },
        updateChart() {
            this.getListPointInClass()
            this.renderChart()
        },
        getListPointInClass() {
            if (this.listMember.length > 0) {
                //Tính số bài đạt điểm từ 0 đến 10
                var lstPostByPoint = [];
                var xaxisCat = [];
                for (let point = 0; point <= 10; point+=0.5) {
                    let count = this.listMember.filter(x => this.formatNumber(x.point * 1) * 1 == point).length
                    if (count > this.yMax) this.yMax = count
                    lstPostByPoint.push(count);
                    if (point % 1 == 0.5) {
                        xaxisCat.push('');
                    }
                    else {
                        xaxisCat.push(point + '');
                    }
                }
                this.options.series = [{
                    name: 'Số bài đạt điểm',
                    data: lstPostByPoint
                }]
                this.options.xaxis.categories = xaxisCat
                this.options.yaxis = {
                    title: {
                        text: 'Số bài đạt điểm'
                    },
                    tickAmount: 10,
                    min: 0,
                    max: this.yMax,
                }
                
            }
        },
        getListMember() {
            this.listMember = []
            this.paramQueryDataMember.classSchoolId = this.classSchoolId
            this.paramQueryDataMember.lessonClassSchoolId = this.lessonClassSchoolId
            getListUserExcerice(this.paramQueryDataMember).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listMember.push({ 
                            'stt': i + 1,
                            'memberName': item.userName,
                            'status': item.status,
                            'point': item.point,
                        })
                    }
                }
            })

        },

    }
}
</script>
<style lang="scss" scoped>

</style>